<app-wrapper>

  <div class="mb-9">
    <div class="row g-3 mb-4">
      <div class="col-auto">
        <h2 class="mb-0">Заказы</h2>
      </div>
    </div>

    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <div class="search-box">
            <div class="position-relative">
              <input type="text" class="form-control search-input search" [(ngModel)]="search"
                name="search" placeholder="Номер заказа" (keyup.enter)="searchItems()" />
                <i class="fa-solid fa-search search-box-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-auto flex-grow-1">

          </div>
          <div class="col-auto">
          </div>
        </div>
      </div>

      <div class="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
        <div class="table-responsive mx-n1 px-1">
          <table class="table fs--1 mb-0">
            <thead>
              <tr>
                <th>Номер</th>
                <th class="text-center">Дата</th>
                <th>Контактные данные</th>
                <th class="text-center">Статус заказа</th>
                <th class="text-center">Статус оплаты</th>
                <th class="text-center">Сумма</th>
              </tr>
            </thead>
            <tbody>
              @for (item of items; track item) {
                <tr>
                  <td><a [routerLink]="['/orders/view/'+item.id]">{{ item.number }}</a></td>
                  <td class="text-center">{{ item.utcDate | date:'dd.MM.yyyy HH:mm:ss' }}</td>
                  <td>{{ item.contactName }} ({{ item.contactPhone }})</td>
                  <td class="table-{{ item.orderStatus | orderStatus : true  }} text-center">
                    {{ item.orderStatus | orderStatus }}
                  </td>
                  <td class="table-{{ item.paymentStatus | paymentStatus : true  }} text-center">
                    {{ item.paymentStatus | paymentStatus }}
                  </td>
                  <td class="text-center">{{ item.totalSum | number: '.2-2' }}</td>
                </tr>
              }
              @if (!isBusy && items.length == 0) {
                <tr>
                  <td colspan="10" class="text-center">
                    Список пуст
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end py-2 pe-0 fs--1">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [ngClass]="{'disabled': page === 1}" (click)="getData(page - 1)">
              <a onclick="return false;" class="page-link" href="#" tabindex="-1">
                <span aria-hidden="true"><i class="fa-solid fa-chevron-left"></i></span>
              </a>
            </li>
            @for (item of getPages(); track item) {
              <li class="page-item"
                [ngClass]="{'active': page === item.page, 'disabled': item.isDisabled}"
                (click)="getData(item.page)">
                <a class="page-link" onclick="return false;" href="#">{{ item.label }}</a>
              </li>
            }
            <li class="page-item" [ngClass]="{ 'disabled': !pages || page === pages }"
              (click)="getData(page + 1)">
              <a onclick="return false;" class="page-link" href="#">
                <span aria-hidden="true"><i class="fa-solid fa-chevron-right"></i></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      @if (isBusy) {
        <div class="overlay">
          <i class="fa-solid fa-spinner fa-spin"></i>
        </div>
      }
    </div>

  </app-wrapper>
